import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import axios from "axios";

export const useUserStore = create(
  persist(
    (set) => ({
      user: null,
      setUser: (user) => {
        set({ user });
      },

      userToken: null,
      setUserToken: (userToken) => set((state) => {
        if (state.userToken !== userToken) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${userToken}`;
          return { userToken };
        }
        return state;
      }),

      isSessionTimedOut: false,
      setIsSessionTimedOut: (value) => set({ isSessionTimedOut: value }),

      logout: () => {
        set({ userToken: null, user: null, isSessionTimedOut: true });
        localStorage.removeItem("userToken");
        localStorage.removeItem("refreshToken");
      },
    }),
    {
      name: 'user-store', // key in localStorage
      partialize: (state) => ({
        user: state.user,
        userToken: state.userToken,
      }),
    }
  )  
);

